import React from 'react';
import './Sections.css';

const Services = () => {
  return (
    <div className="services-container">
      <div className="text-box">
        <div className="inner-box" dir="rtl">
          <h2>אני המאמין שלי.</h2>
          <p>אני מאמין שכל בעיה טכנית ניתנת לפתרון - עם חיוך, סבלנות ושירות אישי.</p>
          <p>השמחה והסיפוק שלי מגיעים כשאני רואה את הלקוחות שלי מרוצים ומשתמשים במחשב שלהם ללא דאגות.</p>
          <p>אני מציע שירותים מגוונים כגון תיקון תקלות חומרה ותוכנה, שדרוג רכיבי מחשב, התקנת מערכות הפעלה, ניקוי ואופטימיזציה של מערכת המחשב, וייעוץ טכני לרכישת מחשבים חדשים וחלקי חילוף.</p>
          <p>המטרה שלי היא לא רק לתקן את המחשב שלכם, אלא לתת לכם את השירות הטוב ביותר, עם יחס אישי וחם, ולהפוך את החוויה הטכנית למהנה ופשוטה.</p>
        </div>
      </div>
    </div>
  );
};

export default Services;
